import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dbb2e51&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb2e51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbb2e51')) {
      api.createRecord('5dbb2e51', component.options)
    } else {
      api.reload('5dbb2e51', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5dbb2e51&scoped=true", function () {
      api.rerender('5dbb2e51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/configure/index.vue"
export default component.exports